export const PagesTableColumns = [
    {
        id: "titleEn",
        labelEn: "Title (EN)",
        labelAr: "العنوان (EN)",
    },
    {
        id: "titleAr",
        labelEn: "Title (AR)",
        labelAr: "العنوان (AR)",
    },
    {
        id: "slug",
        labelEn: "Slug",
        labelAr: "الرابط",
    },
    {
        id: "status",
        labelEn: "Status",
        labelAr: "الحالة",
    },
    {
        id: "createdAt",
        labelEn: "Created At",
        labelAr: "تاريخ الإنشاء",
    },
];
